import React, { useEffect } from "react";
import { useState } from "react";
import "../styles/calculatePercentage.css";

function Input({ type, className, div }) {
  const [finalValue, setFinalValue] = useState("");
  const [percentage, setPercentage] = useState("");
  const [ofValue, setOfValue] = useState("");

  useEffect(() => {
    if (div === "div1") {
      console.log("chlaaaaaa div1");

      if (percentage === "" || finalValue === "") {
        return;
      } else {
        console.log(percentage, finalValue);
        setOfValue(
          ((percentage * finalValue) / 100).toFixed(3).replace(/\.?0+$/, "")
        );
      }
    }

    if (div === "div2") {
      if (ofValue === "" || finalValue === "") {
        return;
      } else {
        console.log("ofvalue", ofValue, "final value", finalValue);
        const val = ((100 * ofValue) / finalValue)
          .toFixed(3)
          .replace(/\.?0+$/, "");
     
        setPercentage(val);
      }
    }

    if (div === "div3") {
      if (percentage === "" || ofValue === "") {
        return;
      } else {
        console.log(percentage, ofValue);
        setFinalValue(
          ((ofValue * 100) / percentage).toFixed(3).replace(/\.?0+$/, "")
        );
      }
    }
  }, [finalValue, percentage, ofValue, div]);

  return (
    // inputBox
    <>
    <div className="calculate-percentage">
      <input
        type={type}
        className={div !== "div1" ? "inputBox dark-input percentage-input-box" : "inputBox percentage-input-box"}
        readOnly={div === "div1" ? true : false}
       
        value={ofValue}
        onChange={(e) => {
          setOfValue(e.target.value);
        }}
      />
      &nbsp; is &nbsp;

      <div className="input-percentage-holder ">
        <input
          type={type}
          className={div !== "div2" ? "inputBox dark-input percentage-input-box" : "inputBox percentage-input-box"}
          readOnly={div === "div2" ? true : false}
          
          value={percentage}
          onChange={(e) => {
            setPercentage(e.target.value);
          }}
        />
        <span className="pecentage-sign">%</span>
      </div>
       of &nbsp;
      <input
        type={type}
        className={div !== "div3" ? "inputBox dark-input percentage-input-box" : "inputBox percentage-input-box"}
        readOnly={div === "div3" ? true : false}
        
        value={finalValue}
        onChange={(e) => {
          setFinalValue(e.target.value);
        }}
      />
      </div>
    </>
  );
}











function CalculatePercentage() {
  return (
    <>
      <h2>Calculate Percentage </h2>


        <Input  type="number" div="div1" />
      

      
        <Input  type="number" div="div2" />
      

     
        <Input type="number" div="div3" />
   
      
    </>
  );
}

export default CalculatePercentage;
